module.exports = __webpack_public_path__ + "img/dywaniki-tekstylne-3-rodzaje-materialu.d70f7cbe.jpg";